import React, { Component } from 'react';
import FileUploaderBlob from './../../../commons/FileUploaderBlob.js';


export default class StockTransfer extends Component {
	render() {
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Stock Transfer
					</div>
					<div className="top-thirty">
						<FileUploaderBlob url="ingest/iwt/imr/create"/>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/InventoryOperations/Components/StockTransfer.js